import type { Playlist } from '../types/video';

export const playlists: Playlist[] = [
  {
    id: 'mountains',
    title: 'Походи по горах',
    description: 'Ґорґани, Чорногора, Боржава — маршрути Карпатами в будь-яку пору року.',
  },
  {
    id: 'oneday',
    title: 'Походи на один день',
    description: 'Вийти зранку, повернутися ввечері: маршрути, які легко повторити за вихідні.',
  },
  {
    id: 'climbing',
    title: 'Скелелазіння',
    description: 'Дениші, Мигія, Леонідіо, Датча — скелі України та світу й змагання з боулдерингу.',
  },
  {
    id: 'eurotrip',
    title: 'Big Eurotrip 2020',
    description: 'Серія влогів: Австрія, Швейцарія, Ліхтенштейн, мультипітч в Імсті та Moto GP.',
  },
];
